import {
  EWidgetSource,
  IBuyAndHoldPackageRequest,
} from '../../../repositories/billing-service-packages-balancer/v2/buy-and-hold-package';
import { IBuyAndHoldPackageParameters } from '../types';

export const mapParameters = (parameters: IBuyAndHoldPackageParameters): IBuyAndHoldPackageRequest => {
  const { packageId, polygonIds, autoProlong, widgetSource, useBalance, useBalanceAmount } = parameters;

  return {
    packageId,
    polygonIds,
    autoProlong,
    widgetSource: widgetSource as string as EWidgetSource,
    useBalance,
    useBalanceAmount,
  };
};
